<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="w-48 p-4 whitespace-nowrap text-sm text-gray-500">
      <img :src="media.url" class="rounded" />
    </td>
    <td class="p-4 whitespace-nowrap text-sm text-gray-500">
      <div class="flex space-x-2 justify-end">
        <MediaListItemCoverAction v-if="!isCover" :media-id="media.id">
          Set as Cover
        </MediaListItemCoverAction>
        <MediaListItemDeleteAction :acc-product-id="accProductId" :media-id="media.id">
          Delete
        </MediaListItemDeleteAction>
      </div>
    </td>
  </tr>
</template>

<script>
import MediaListItemCoverAction from './MediaListItemCoverAction.vue';
import MediaListItemDeleteAction from './MediaListItemDeleteAction.vue';

export default {
  components: {
    MediaListItemCoverAction,
    MediaListItemDeleteAction,
  },
  props: {
    accProductId: {
      type: String,
      required: true,
    },
    mediaId: {
      type: String,
      required: true,
    },
    isCover: Boolean,
  },
  computed: {
    media() {
      return this.$store.state.entities.media.byId[this.mediaId];
    },
  },
};
</script>
